(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('purchase-present-item', {
            parent: 'entity',
            url: '/purchase-present-item?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchasePresentItem.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-items.html',
                    controller: 'PurchasePresentItemController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItem');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }]
            }
        })
        .state('purchase-present-item-detail', {
            parent: 'entity',
            url: '/purchase-present-item/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.purchasePresentItem.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-detail.html',
                    controller: 'PurchasePresentItemDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('purchasePresentItem');
                    $translatePartialLoader.addPart('tradePolicyRuleTypeEnum');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PurchasePresentItem', function($stateParams, PurchasePresentItem) {
                    return PurchasePresentItem.get({id : $stateParams.id});
                }]
            }
        })
        .state('purchase-present-item.new', {
            parent: 'purchase-present-item',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-dialog.html',
                    controller: 'PurchasePresentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantity: null,
                                price: null,
                                quantityExecuted: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('purchase-present-item');
                });
            }]
        })
        .state('purchase-present-item.edit', {
            parent: 'purchase-present-item',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-dialog.html',
                    controller: 'PurchasePresentItemDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PurchasePresentItem', function(PurchasePresentItem) {
                            return PurchasePresentItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('purchase-present-item.delete', {
            parent: 'purchase-present-item',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/purchase-present-item/purchase-present-item-delete-dialog.html',
                    controller: 'PurchasePresentItemDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PurchasePresentItem', function(PurchasePresentItem) {
                            return PurchasePresentItem.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('purchase-present-item', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
